import { Toaster as UIToaster } from '@journ/ui/toaster'

const Toaster = () => <UIToaster />

export { Toaster }
